module.exports = __webpack_public_path__ + "img/desc_bottom_zj4361.3c7aeb59.png";